/**
 * Browser implementations of the media analysis/derivative contracts (see `../types.ts`).
 */
import type { DerivativeCache, DerivativeGenerator, MediaAnalyzer } from '../types.ts';
import { BrowserMediaAnalyzer } from './browser-analyzer.ts';
import { BrowserDerivativeGenerator } from './browser-derivatives.ts';
import { OpfsDerivativeCache } from './opfs-cache.ts';

export { BrowserMediaAnalyzer, BrowserDerivativeGenerator, OpfsDerivativeCache };
export { WaveformBuilder, WAVEFORM_RATE } from './waveform-builder.ts';
export * from './plans.ts';

export function createBrowserAnalyzer(): MediaAnalyzer {
  return new BrowserMediaAnalyzer();
}

export function createBrowserDerivatives(): DerivativeGenerator {
  return new BrowserDerivativeGenerator();
}

export function createOpfsCache(): DerivativeCache {
  return new OpfsDerivativeCache();
}
